import { render, staticRenderFns } from "./PaymentModal.vue?vue&type=template&id=af7a743c&scoped=true&"
import script from "./PaymentModal.vue?vue&type=script&lang=js&"
export * from "./PaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentModal.vue?vue&type=style&index=0&id=af7a743c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7a743c",
  null
  
)

export default component.exports